import React, { useEffect, useState } from "react";
import { Footer } from "../../Footer";
import DataTable from "react-data-table-component";
import { Button, Col, Form, Row } from "react-bootstrap";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import * as icons from "react-bootstrap-icons";
import {
  SportAllMap,
  TeamAll,
  TeamAllSearch,
  TeamDelete,
  TeamGetAll,
  TeamReg,
  TeamUpdate,
} from "../../redux/auth-reducer/auth-service";
import { useImageUpload } from "../../hooks/useImageUpload";
import { ImageUrl } from "../../utils/config/config";
import { readApiMessage } from "../../utils/helper/helper";
import { IMAGE_STILL_UPLOADING } from "../../utils/helper/imageUpload";
import { ModalBox } from "../Outer/Modal";
import { ToastContainer, toast } from "react-toastify";
import { TeamFormFields } from "./TeamFormFields";
import { FormActions } from "./FormActions";
import { ConfirmDeleteModal } from "./ConfirmDeleteModal";

// The logo a team without its own image shows, in the list and in Update Team.
const TEAM_ICON = "../image/team-icon.png";

// The Add Team form before anything is typed. sportId "" is the "Select Sports" option, which the
// required select refuses.
const EMPTY_TEAM = { teamId: "", teamName: "", teamImage: null, sportId: "" };

export const Team = () => {
  const [data, setData] = useState();
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [itemList, setItemList] = useState("");
  const [sportData, setSportData] = useState([]);
  const [count, setCount] = useState(0);
  const [deleteRow, setDeleteRow] = useState(null);
  const [showEdit, setShowEdit] = useState();
  // #10: the logo each form saves. See useImageUpload for what a failed upload does.
  const addLogo = useImageUpload();
  const editLogo = useImageUpload();
  const [pageSize, setPageSize] = useState();
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const pageOptions = [10, 20, 30, 50];
  const [editData, setEditData] = useState({
    sportID: 0,
    teamImage: "",
    sportName: "",
    sportId: 0,
  });
  const [searchText, setSearchText] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [teamReg, setTeamReg] = useState(EMPTY_TEAM);

  function sidebarfun() {
    setData(!data);
  }

  const TeamAllFn = async (data) => {
    try {
      const response = await TeamAll(data); // Call your API function
      if (response?.data) {
        setItemList(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    TeamAllFn(data); // Fetch data when currentPage changes
  }, [currentPage, count]);

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);
    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    TeamAllFn(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  const handlePageChange = (page) => {
    setPageNo(page);
    const data = {
      PageNumber: page,
      PageSize: perPage,
    };
    TeamAllFn(data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    const data = {
      PageNumber: page,
      PageSize: newPerPage,
    };
    await TeamAllFn(data);
  };

  useEffect(() => {
    const SportData = async () => {
      await SportAllMap().then((response) => {
        setSportData(response?.data?.data?.dataList);
      });
    };

    SportData();
  }, []);

  const columns = [
    {
      name: <strong>ID</strong>,
      selector: (row, index) => (currentPage - 1) * perPage + index + 1,

      width: "80px",
    },
    {
      name: <strong>Logo</strong>,
      selector: (row) => (
        <>
          {row.teamImage == null ? (
            <img
              src={TEAM_ICON}
              width={50}
              className="img-fluid pt-3 pb-3"
            />
          ) : (
            <img
              src={ImageUrl + row?.teamImage}
              width={50}
              className="img-fluid pt-3 pb-3"
            ></img>
          )}
        </>
      ),
    },
    {
      name: <strong>Team Name</strong>,
      selector: (row) => row?.teamName,
      sortable: true,
    },

    {
      name: <strong>Sport Name </strong>,
      selector: (row) => row?.sportName,
      sortable: true,
    },

    {
      name: <strong>Action</strong>,
      // canEdit comes from usp_GetAllTeamData, which computes it from the same ownership rule
      // usp_CRUDTeam and usp_DeleteTeamById enforce. Every row used to offer Edit and Delete
      // unconditionally, so acting on another manager's team only failed once the request
      // came back. Disabled rather than hidden, matching Tournament.js.
      selector: (row) => (
        <>
          <button
            type="button"
            disabled={!row?.canEdit}
            className={
              row?.canEdit
                ? "text-danger btn-aucion"
                : "text-danger btn-aucion disabled"
            }
            onClick={() => deleteFn(row)}
          >
            <icons.Trash />
          </button>
          <button
            type="button"
            disabled={!row?.canEdit}
            className={
              row?.canEdit
                ? "text-success btn-aucion"
                : "text-success btn-aucion disabled"
            }
            onClick={() => editFn(row)}
          >
            <icons.PencilSquare />
          </button>
        </>
      ),
      width: "150px",
    },
  ];

  const editFn = (editItem) => {
    setShowEdit(true);
    // #306: Add and Update share `validated`; a refused Add must not open Update in red.
    setValidated(false);
    setEditData(editItem);
    // #10: the edit starts from the team's own logo. It started from none, and the save sends what
    // this holds, so renaming a team erased its logo.
    editLogo.reset(editItem?.teamImage);
  };

  // #307: the whole row, so the confirmation can name the team.
  const deleteFn = async (row) => {
    setShowDeleteModal(true);
    setDeleteRow(row);
  };

  // const handleSearch = (e) => {
  //     setSearchText(e.target.value);
  // };

  const TeamAllFnSearch = async (data) => {
    try {
      const response = await TeamAllSearch(data); // Call your API function
      if (response?.data) {
        setItemList(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    if (value.length === 1 && value === " ") {
      return; // Ignore the input if it's just a space
    }
    setSearchText(value);
    const data = {
      SearchTerm: value,
      SortOrder: false,
      SortColumn: "TeamName",
    };
    TeamAllFnSearch(data);
  };

  const filteredData = searchText
    ? itemList?.filter((item) => {
        return (
          item?.teamName?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.sportName?.toLowerCase().includes(searchText?.toLowerCase())
        );
      })
    : itemList;

  // #10: a logo uploaded and then cancelled used to stay behind and be saved with the next team.
  // #306: so did the name and sport, now that the fields show what the form will send.
  const AddTeam = () => {
    addLogo.reset();
    setTeamReg(EMPTY_TEAM);
    setValidated(false);
    setShow(true);
  };
  const handleClosed = () => {
    setShowDeleteModal(false);
    setShow(false);
    setShowEdit(false);
    setIsButtonDisabled(true);
  };

  const handelTeam = (e) => {
    setTeamReg({
      ...teamReg,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setLoading(true);
    // Stop here when the form is invalid. This used to set the red-outline styling and then fall
    // straight through to the POST, so leaving the sport dropdown on "Select Sports" sent
    // sportId: 0 -- a team stored against a sport that does not exist, and thereafter invisible
    // in every list because the read procedures INNER JOIN tblSports (WEB-94). The server refuses
    // it now too; this is what stops the pointless round trip.
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      setLoading(false);
      return;
    }
    // #10: this used to test `imageResponse?.status == false` - the HTTP status, never false - so a
    // failed upload still saved the team without its logo. useImageUpload never takes a failed
    // upload's name, so only an upload still on its way has to be waited for.
    if (addLogo.uploading) {
      toast.error(IMAGE_STILL_UPLOADING);
      setLoading(false);
      return;
    }

    const registerData = [
      {
        teamId: 0,
        teamName: teamReg.teamName,
        teamImage: addLogo.name || null,
        sportId: Number(teamReg.sportId),
      },
    ];

    await TeamReg(registerData).then((res) => {
      if (res?.data?.status === true) {
        setCount(count + 1);
        setIsButtonDisabled(true);
        toast.success(res?.data?.message);
        setShow(false);
        setLoading(false);
        addLogo.reset();
        setValidated(false);

        setTeamReg(EMPTY_TEAM);
      } else {
        toast.error(readApiMessage(res));
        setLoading(false);
      }
    });
  };

  const handelDelete = async () => {
    await TeamDelete(deleteRow?.teamId).then((res) => {
      if (res?.status == true) {
        setCount(count + 1);
        toast.success(res?.message);
        setIsButtonDisabled(true);
        setShowDeleteModal(!showDeleteModal);
      } else {
        toast.error(readApiMessage(res));
      }
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    // The edit form never validated at all: parseInt("") on the placeholder gives NaN, which
    // JSON.stringify emits as null, and the save failed on the server for a reason the user was
    // never shown. The markup already carries noValidate/validated and the sport select is
    // required, so checkValidity() reports it with no change to the JSX (WEB-94).
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setValidated(true);
    if (editLogo.uploading) {
      toast.error(IMAGE_STILL_UPLOADING);
      return;
    }
    // usp_CRUDTeam writes TeamImage as sent, so this is the team's current logo unless a new one
    // was uploaded (#10).
    const registerData = {
      teamId: editData?.teamId,
      teamName: editData?.teamName,
      teamImage: editLogo.name || null,
      sportId: parseInt(editData?.sportId),
    };

    await TeamUpdate(registerData).then((res) => {
      if (res?.status == true) {
        setValidated(false);
        setCount(count + 1);
        toast.success(res?.message);
        setShowEdit(false);
      } else {
        toast.error(readApiMessage(res));
      }
    });
  };
  const handelEditTeam = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const clearSearch = () => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    TeamAllFn(data);
    setSearchText("");
  };
  return (
    <>
      <ConfirmDeleteModal
        show={showDeleteModal}
        entity="team"
        name={deleteRow?.teamName}
        onConfirm={handelDelete}
        onCancel={handleClosed}
      />

      <ModalBox
        show={showEdit}
        onHide={handleClosed}
        title="Update Team"
        body={
          <>
            {/* #306: the same fields and layout as Add Team (TeamFormFields). */}
            <Form noValidate validated={validated} onSubmit={handleUpdate}>
              {/* #10: the logo the update will save, not the file picked: an upload that failed
                  leaves the current one. */}
              <TeamFormFields
                idPrefix="edit-team"
                values={editData}
                onChange={handelEditTeam}
                sports={sportData}
                image={editLogo}
                placeholderImage={TEAM_ICON}
              />

              <FormActions onCancel={handleClosed} submitLabel="Update" />
            </Form>
          </>
        }
      />

      <ModalBox
        show={show}
        title="Add Team"
        body={
          <>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <TeamFormFields
                idPrefix="add-team"
                values={teamReg}
                onChange={handelTeam}
                sports={sportData}
                image={addLogo}
                busy={loading}
              />
              <FormActions onCancel={handleClosed} />
            </Form>
          </>
        }
      />

      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row>
            <Col md={6}>
              <h1 className="heading-dash">Teams</h1>
            </Col>
            <Col md={6} className="text-right">
              <Button
                className="primary button-create-auction "
                onClick={AddTeam}
              >
                <icons.Plus class="icon-plus" /> Add Team
              </Button>
            </Col>
          </Row>

          <div className="group_data_table team-list">
            {/* <div className='search-input d-flex align-items-center'>
                            <input type="text" className='form-control mb-3 mt-3' placeholder="Search..." value={searchText} onChange={handleSearch} />
                        </div> */}
            <div className="search-input d-flex align-items-center">
              <input
                type="text"
                className="form-control mb-3 mt-3"
                placeholder="Search..."
                value={searchText}
                onChange={handleSearch}
              />
              {searchText && (
                <button className="btn btn-clear" onClick={clearSearch}>
                  <span>&times;</span> {/* This represents the close icon */}
                </button>
              )}
            </div>
            <div>
              <DataTable
                title="Team List"
                columns={columns}
                data={filteredData}
                paginationPerPage={perPage}
                paginationTotalRows={totalRows * 10}
                paginationDefaultPage={currentPage}
                onChangePage={setCurrentPage}
              />
              <Row>
                <Col md={12} className="text-right">
                  <div className="pagination-controls">
                    {totalRows > 1 ? (
                      <>
                        <label>Rows per page: </label>{" "}
                        <select
                          id="itemsPerPage"
                          value={perPage}
                          onChange={handlePerPageChange}
                        >
                          {pageOptions.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      </>
                    ) : (
                      ""
                    )}
                    <Button
                      onClick={handlePreviousPage}
                      disabled={currentPage === 1}
                    >
                      <icons.ArrowLeft></icons.ArrowLeft>
                    </Button>
                    <span>
                      {" "}
                      {currentPage} of {totalRows}{" "}
                    </span>
                    <Button
                      onClick={handleNextPage}
                      disabled={currentPage >= Math.ceil(totalRows)}
                    >
                      <icons.ArrowRight></icons.ArrowRight>
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
